import React from 'react';
import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';

export const MedicalFormPartB = () => {
  const { t } = useTranslation();

  return (
    <div className="medical-declaration-part-b">
      <Row className="section-title">
        <Col md="6">
          <div>{t('MEDICAL_DECLARATION_PART_B_TITLE')}</div>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <div className="medical-declaration-paragraph-explain">
            {t('MEDICAL_DECLARATION_PART_B_FIRST_EXPLAIN')}
          </div>
        </Col>
        <Col md="12">
          <div className="medical-declaration-paragraph">
            {t('MEDICAL_DECLARATION_PART_B_SECOND_EXPLAIN')}
          </div>
        </Col>
        <Col md="12">
          <div className="medical-declaration-paragraph">
            {t('MEDICAL_DECLARATION_PART_B_THIRD_EXPLAIN')}
          </div>
        </Col>
      </Row>
    </div>
  );
};
